import React from "react";

const PlusIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="plus_icon"
      data-name="plus"
      {...props}
      width={props.width || "20"}
      height={props.height || "21"}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8334 9.66663H10.8334V4.66663H9.16675V9.66663H4.16675V11.3333H9.16675V16.3333H10.8334V11.3333H15.8334V9.66663Z"
        fill={props.fill || "white"}
      />
    </svg>
  );
};

export default PlusIcon;
